import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { BehaviorSubject, EMPTY, Observable, of } from 'rxjs';
import { UtilityService } from '../services/utility.service';
import { switchMap, tap } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
declare var Razorpay: any;
@Injectable({
  providedIn: 'root'
})
export class ThirdPartyService {

  baseUrl!: String;

  private searchKeyword: string = '';

  private productListCache: any[] = [];

  private productListLengthCache: number = 0;

  private scriptLoaded = false;


  private parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // Selected seller state (for passing between list and detail components)
  private selectedSellerSubject = new BehaviorSubject<any>(null);
  public selectedSeller$ = this.selectedSellerSubject.asObservable();

  constructor(
    private configService: ConfigService,
    public http: HttpClient,
    private utilityService: UtilityService,
    private sanitizer: DomSanitizer,
  ) {
    this.baseUrl = this.configService.getBaseUrl()
  }

  setSearchKeyword(keyword: string) {
    this.searchKeyword = keyword;
  }

  getSearchKeyword(): string {
    return this.searchKeyword;
  }

  setProductListCache(products: any[], length: number) {
    this.productListCache = products;
    this.productListLengthCache = length;
  }

  getProductListCache(): any[] {
    return this.productListCache;
  }

  getProductListLengthCache(): number {
    return this.productListLengthCache;
  }

  setSelectedSeller(seller: any) {
    this.selectedSellerSubject.next(seller);
  }

  getSelectedSeller(): Observable<any> {
    return this.selectedSeller$;
  }

  getSelectedSellerValue(): any {
    return this.selectedSellerSubject.value;
  }

  clearSelectedSeller(): void {
    this.selectedSellerSubject.next(null);
  }

  public getLoginDetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? '{}');
  }

  public getThirdPartyUserKeyFromUrl(): string | null {
    return this.utilityService.getParamValueFromAnyUrl('thirdpartyuserkey');
  }

  public paramThirdPartyUserExistsInUrl(): boolean {
    return this.utilityService.paramExistsInAnyUrl('thirdpartyuserkey');
  }

  public getWorkOrdersWithTotal(params: any) { //params:any

    let sendingData = {
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      shopID: params.shopID,
      keyWord: params.keyWord,
      statusType: params.statusType,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      branchID: params.branchID,
      createdUser: params.createdUser,
      assignedUser: params.assignedUser,
      paymentType: params.paymentType,
      filterByReminderDate: params.filterByReminderDate,
      isSentReminder: params.isSentReminder,
      branchName: params.branchName,
      shopName: params.shopName,
      staffName: params.staffName,
      isShop: params.isShop,
      userAvailableStatuses: params.userAvailableStatuses,
      combineAssignedUserWithSearch: params.combineAssignedUserWithSearch
    }

    let url = this.baseUrl + '/Servicenear/GetWorkOrdersWithTotal'
    return this.http.post(url, sendingData, this.parseHeaders);

  }

  public getWorkOrdersCount(params: any) {
    let sendingData = {
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      shopID: params.shopID,
      keyWord: params.keyWord,
      statusType: params.statusType,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      branchID: params.branchID,
      createdUser: params.createdUser,
      assignedUser: params.assignedUser,
      paymentType: params.paymentType,
      filterByReminderDate: params.filterByReminderDate,
      isSentReminder: params.isSentReminder,
      branchName: params.branchName,
      shopName: params.shopName,
      staffName: params.staffName,
      isShop: params.isShop,
      userAvailableStatuses: params.userAvailableStatuses,
      combineAssignedUserWithSearch: params.combineAssignedUserWithSearch
    }
    let url = this.baseUrl + '/Servicenear/GetWorkOrderCount'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getWorkOrderByID(params: any) {
    let sendingData = {
      UserID: params.UserID,
      workId: params.workId
    }
    var url = this.baseUrl + '/Servicenear/GetWorkOrderBYID'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public CheckOutOrderForPOS(param: any) {
    const seller = this.getSellerDetails()
    let sendingData = {
      orderHeader: {
        id: 0,
        userID: param.orderHeader.userID,
        billNo: '',
        totalAmount: param.orderHeader.productTotalAmount,
        deliveryType: param.orderHeader.DeliveryType,
        customerName: param.orderHeader.CustomerName,
        customerPhone: param.orderHeader.CustomerPhone,
        deliveryAddress: param.orderHeader.DeliveryAddress,
        deliveryPlace: param.orderHeader.DeliveryPlace,
        deliveryLandMark: param.orderHeader.DeliveryLandMark,
        deliveryPincode: param.orderHeader.DeliveryPincode,
        deliveryCountry: param.orderHeader.DeliveryCountry,
        deliveryState: param.orderHeader.DeliveryState,
        deliveryCity: param.orderHeader.DeliveryCity,
        orderStatus: param.orderHeader.orderStatus,
        orderHeader: '',
        createdBy: seller.UserID,
        createdOn: new Date(),
        updatedBy: seller.UserID,
        updatedOn: new Date(),
        itemsCount: param.orderHeader.ItemsCount,
        directBuyNo: 0,
        sellerID: 0,
        organisationID: 0,
        studentName: '',
        studyingClass: '',
        appliedPromocode: '',
        appliedDiscount: param.orderHeader.appliedDiscount,
        referencePhoneNumber: '',
        deliveryUniqueId: param.orderHeader.DeliveryUniqueId,
        deliveryPartner: param.orderHeader.deliveryPartner,
        deliveryCost: param.orderHeader.totalDeliveryCharge,
        customerPhoneNumberInDeliveryAddress: param.orderHeader.contactNumber,
        paymentType: param.orderHeader.paymentType,
        discountBreakdown: param.orderHeader.discountBreakdown,
        updateThirdPartyOrder: param.orderHeader.updateThirdPartyOrder,
        serviceCost: param.orderHeader.serviceCost,
        partsQty: param.orderHeader.partsQty,
        partsCost: param.orderHeader.partsCost,
        branchId: param.orderHeader.branchId,
        workId: param.orderHeader.workId,
        changeToReturned: param.orderHeader.changeToReturned,
        totalReceivedAmount: param.orderHeader.totalReceivedAmount,
        paymentModes: param.orderHeader.paymentModes,
        advanceAmount: param.orderHeader.advanceAmount,
        saleType: param.orderHeader.saleType
      },
      orderDetails: param.orderDetails.map((item: any) => ({
        userID: item.userID,
        productID: item.productID,
        price: item.price,
        quantity: item.quantity,
        createdBy: seller.UserID,
        organisationID: 0,
        unknownUserKey: ''
      })),
      productUpdateDetails: param.productUpdateDetails,
    };
    let url = this.baseUrl + '/Order/CheckOutOrderForPOS';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public UpdateOrderWithDetailsForPOS(param: any) {
    const seller = this.getSellerDetails()
    let sendingData = {
      modifiedDetails: param.modifiedDetails.map((item: any) => ({
        detailId: item.detailId,
        productID: item.productID,
        price: item.price,
        quantity: item.quantity,
        mrp: item.mrp,
        totalPrice: item.totalPrice,
        purchasePrice: item.purchasePrice,
      })),
      deletedDetails: param.deletedDetails.map((item: any) => ({
        detailId: item.detailId,
        productID: item.productID,
        price: item.price,
        quantity: item.quantity,
        mrp: item.mrp,
        totalPrice: item.totalPrice,
        purchasePrice: item.purchasePrice,
      })),
      addedDetails: param.addedDetails.map((item: any) => ({
        detailId: item.detailId,
        productID: item.productID,
        price: item.price,
        quantity: item.quantity,
        mrp: item.mrp,
        totalPrice: item.totalPrice,
        purchasePrice: item.purchasePrice,
      })),
      productUpdateDetails: param.productUpdateDetails,

      id: param.orderHeader.id,
      userID: param.orderHeader.userID,
      billNo: '',
      totalAmount: param.orderHeader.productTotalAmount,
      deliveryType: param.orderHeader.DeliveryType,
      customerName: param.orderHeader.CustomerName,
      customerPhone: param.orderHeader.CustomerPhone,
      deliveryAddress: param.orderHeader.DeliveryAddress,
      deliveryPlace: param.orderHeader.DeliveryPlace,
      deliveryLandMark: param.orderHeader.DeliveryLandMark,
      deliveryPincode: param.orderHeader.DeliveryPincode,
      deliveryCountry: param.orderHeader.DeliveryCountry,
      deliveryState: param.orderHeader.DeliveryState,
      deliveryCity: param.orderHeader.DeliveryCity,
      orderStatus: param.orderHeader.orderStatus,
      orderHeader: '',
      createdBy: seller.UserID,
      createdOn: new Date(),
      updatedBy: seller.UserID,
      updatedOn: new Date(),
      itemsCount: param.orderHeader.ItemsCount,
      directBuyNo: 0,
      sellerID: 0,
      organisationID: 0,
      studentName: '',
      studyingClass: '',
      appliedPromocode: '',
      appliedDiscount: param.orderHeader.appliedDiscount,
      referencePhoneNumber: '',
      deliveryUniqueId: param.orderHeader.DeliveryUniqueId,
      deliveryPartner: param.orderHeader.deliveryPartner,
      deliveryCost: param.orderHeader.totalDeliveryCharge,
      customerPhoneNumberInDeliveryAddress: param.orderHeader.contactNumber,
      paymentType: param.orderHeader.paymentType,
      discountBreakdown: param.orderHeader.discountBreakdown,
      updateThirdPartyOrder: param.orderHeader.updateThirdPartyOrder,
      serviceCost: param.orderHeader.serviceCost,
      partsQty: param.orderHeader.partsQty,
      partsCost: param.orderHeader.partsCost,
      branchId: param.orderHeader.branchId,
      workId: param.orderHeader.workId,
      changeToReturned: param.orderHeader.changeToReturned,
      totalReceivedAmount: param.orderHeader.totalReceivedAmount,
      paymentModes: param.orderHeader.paymentModes,
      advanceAmount: param.orderHeader.advanceAmount,
      cartUniqueKey: param.orderHeader.cartUniqueKey,
    };
    let url = this.baseUrl + '/Order/UpdateOrderWithDetailsForPOS';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getBranchUsers(params: any) {
    let sendingData = {
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      branchID: params.branchID,
      userType: params.userType
    }
    let url = this.baseUrl + '/Servicenear/GetBranchUsers';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getProductList(params: any) {
    let sendingData = {
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      categoryID: params.categoryID,
      keyword: params.keyword,
      productsFor: params.productsFor,
      productsType: params.productsType,
      organisationID: params.OrganisationID,
      showInactiveProductsOnly: params.ShowInactiveProductsOnly ?? false,
      showUnpublishedProductsOnly: params.ShowUnpublishedProductsOnly ?? false,
      showOutofStockProductsOnly: params.ShowOutOfStockProductsOnly ?? false,
    }
    var url = this.baseUrl + '/Products/GetProducts'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateWorkOrderStatusByBranchType(params: any) {
    let sendingData = {
      id: params.id,
      createdBy: params.createdBy,
      customerDescription: params.customerDescription,
      minServiceCost: params.minServiceCost,
      maxServiceCost: params.maxServiceCost,
      workDescription: params.workDescription,
      workStatus: params.workStatus,
      updatedOn: params.updatedOn,
      branchID: params.branchID,
      serviceCost: params.serviceCost,
      finalCost: params.finalCost,
      collectedPerson: params.collectedPerson,
      collectedPersonNo: params.collectedPersonNo,
      transferBranch: params.transferBranch,
      transferType: params.transferType,
      branchType: params.branchType,
      partsCost: params.partsCost,
      warrantyData: params.warrantyData,
      approvedAmount: params.approvedAmount,
      cost: params.cost,
      payment: params.payment,
      discount: params.discount,
      balance: params.balance,
      changeOnly: params.changeOnly,
      issms: params.issms
    };
    let url = this.baseUrl + '/Servicenear/UpdateWorkOrderStatusByBranchType';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateWorkOrderByBranchType(params: any) {
    let userDetails = this.getLoginDetails();

    const sendingData = {
      id: params.id,
      branchID: params.branchID,
      updatedBy: Number(userDetails.UserID),
      shopName: params.shopName,
      manufacture: params.manufacture,
      modelName: params.modelName,
      workDescription: params.workDescription,
      pattern: params.pattern,
      createdOn: params.createdOn,
      deliveryDate: params.deliveryDate,
      updatedOn: params.updatedOn,
      imei: params.imei,
      accessories: params.accessories,
      contactPerson: params.contactPerson,
      contactNo: params.contactNo,
      emailID: params.emailID,
      contactAddress: params.contactAddress,
      minServiceCost: params.minServiceCost,
      maxServiceCost: params.maxServiceCost,
      advanceServiceCost: params.advanceServiceCost,
      serviceCost: params.serviceCost,
      assignedUserID: params.assignedUserID,
      assignedUser: params.assignedUser,
      deviceType: params.deviceType,
      assignedUserName: params.assignedUserName,
      branchType: params.branchType,
      deviceImage: params.deviceImage,
      approvedAmount: params.approvedAmount,
      cost: params.cost,
      payment: params.payment,
      discount: params.discount,
      balance: params.balance,
      changeOnly: params.changeOnly
    }
    let url = this.baseUrl + '/Servicenear/UpdateWorkOrderByBranchType';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getStatusList(params: any) {
    let sendingData = {
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      branchID: params.branchID,
      userType: params.userType
    }
    var url = this.baseUrl + '/Servicenear/GetStatusList'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public insertWorkOrderWithBranchType(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      id: params.id,
      branchID: params.branchID,
      branchName: params.branchName,
      createdBy: params.createdBy,
      manufactureName: params.manufactureName,
      modelName: params.modelName,
      workCaption: params.workCaption,
      workDescription: params.workDescription,
      workStatus: params.workStatus,
      createdOn: params.createdOn,
      deliveryDate: params.deliveryDate,
      updatedOn: params.updatedOn,
      imei: params.imei,
      contactPerson: params.contactPerson,
      contactNo: params.contactNo,
      issms: params.issms,
      emailID: params.emailID,
      contactAddress: params.contactAddress,
      accessories: params.accessories,
      selectedItem: params.selectedItem,
      selectedItem1: params.selectedItem1,
      pattern: params.pattern,
      shopName: params.shopName,
      minServiceCost: params.minServiceCost,
      maxServiceCost: params.maxServiceCost,
      advanceServiceCost: params.advanceServiceCost,
      forCompany: params.forCompany,
      assignedUserID: params.assignedUserID,
      assignedUser: params.assignedUser,
      deviceType: params.deviceType,
      branchType: params.branchType,
      isBooking: params.isBooking,
      bookingID: params.bookingID,
      deviceImage: params.deviceImage,
      approvedAmount: params.approvedAmount,
      cost: params.cost,
      payment: 0,
      discount: 0,
      balance: 0,
      emitionBenchMark: params.emitionBenchMark,
      yearOfManufacture: params.yearOfManufacture,
      isWhatsappEnabled: false
    }

    let url = this.baseUrl + '/Servicenear/InsertWorkOrderWithBranchType'
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getShops(userId: any) {
    let url = this.baseUrl + '/Servicenear/GetShops?UserID=' + userId;
    return this.http.get(url, this.parseHeaders);
  }

  public getSellerDetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? "null");
  }

  // public getUserPrivileges() {
  //   const sellerDetails = this.getSellerDetails();
  //   let sendingData = {
  //     UserID: sellerDetails.UserID
  //   }
  //   let url = this.baseUrl + '/User/GetUserPrivileges'
  //   return this.http.post(url, sendingData, this.parseHeaders);
  // }

  public getStaffIdAndBrandchId() {
    const sellerDetails = this.getSellerDetails();
    let sendingData = {
      sellerUniqueValue: sellerDetails.Uuid,
      userUniqueValue: sellerDetails.UserID
    }
    let url = this.baseUrl + '/Servicenear/GetStaffIdAndBranchIdForSalesPOS';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // Job slip print settings of a ServiceNear branch (PrintSettings JSON + print on/off)
  public getPrinterSettings(params: any) {
    let sendingData = {
      key: '',
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: false,
      fromDate: new Date().toISOString(),
      toDate: new Date().toISOString(),
      branchID: params.branchID,
      userType: ''
    }
    let url = this.baseUrl + '/Servicenear/GetPrinterSettings';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updatePrintSettings(params: any) {
    let sendingData = {
      branchID: params.branchID,
      printSettings: params.printSettings,
      enabledPrint: params.enabledPrint,
    }
    let url = this.baseUrl + '/Servicenear/UpdatePrintSettings';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getPhoneNamesByBranchType() {
    let branchType = 'computer'
    let url = `${this.baseUrl}/Servicenear/GetPhoneNamesByBranchType?BranchType=${branchType}`;
    return this.http.get(url, this.parseHeaders);
  }

  public getPhoneModelNamesByBranchType() {
    let branchType = 'computer'
    let url = `${this.baseUrl}/Servicenear/GetPhoneModelNamesByBranchType?BranchType=${branchType}`;
    return this.http.get(url, this.parseHeaders);
  }

  public getDeviceTypesByBranchType() {
    let branchType = 'computer'
    let url = `${this.baseUrl}/Servicenear/GetDeviceTypesByBranchType?BranchType=${branchType}`;
    return this.http.get(url, this.parseHeaders);
  }

  public updateSalesPOSOrderID(workOrderId: number, salesPosOrderId: number) {
    const sendingData = {
      workOrderId: workOrderId,
      salesPosOrderId: salesPosOrderId
    }
    let url = this.baseUrl + '/Servicenear/UpdateSalesPosOrderId';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getOrderDetails(params: any) {
    let sendingData = {
      ID: params,
    };
    let url = this.baseUrl + '/Order/GetOrderDetails';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getPaymentModesBySeller() {
    let userDetails = this.getLoginDetails();
    let url = this.baseUrl + '/Accounts/GetPaymentModesBySeller';
    return this.http.get(url);
  }

  public GetAllTransactionsFromAccountsBySeller(params: any) {
    let sendingData = {
      key: '',
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      shopId: 0,
      orderID: params.orderID ? params.orderID : 0
    };
    let url = this.baseUrl + '/Accounts/GetTransactionList';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateRefund(params: any) {
    const seller = this.getSellerDetails();
    let sendingData = {
      orderId: params.orderId,
      sellerID: 0,
      createdBy: seller.UserID,
      customerName: params.customerName,
      customerID: params.customerID,
      sellerName: '',
      totalAmount: params.totalAmount,
      paymentModes: params.paymentModes,
    }
    let url = this.baseUrl + '/Order/UpdateRefund';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public addProduct(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      createdBy: Number(userDetails.UserID),
      updatedBy: Number(userDetails.UserID),
      sellerID: 0,
      name: params.name,
      categoryID: params.categoryID || 0,
      unitPrice: params.unitPrice,
      purchasePrice: params.purchasePrice,
      mrp: params.mrp || params.unitPrice,
      discount: params.discount || 0,
      mrpDiscount: params.mrpDiscount,
      cgst: 0,
      sgst: 0,
      productType: params.productType,
      isProductPublished: false,
      description: '',
      searchKeywords: '',
      autoOutOfStock: false,
      stock: 0,
      productWeight: '',
      deliveryChargeProductID: 0,
      sellerPriceConfig: '[]',
      resellingPriceConfig: '[]',
      isReselling: false,
      image: '',
      multiImages: '[]',
      isItemVariant: false,
      currentVariantData: '[]',
      productVariants: [],
      parentProductId: 0,
      hasVariants: false,
      variantGroup: 0,
      modificationNotificationConfig: '[]',
      productSeoData: '',
      externalLinks: '',
      additionalInfo: '',
      "customDetails": "",
      "subCategoryID": "0",
      "unitName": "",
      productTag: params.productTag ?? "",
    };
    let url = this.baseUrl + '/Products/AddProduct';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public returnOrderForPOS(params: any) {
    const seller = this.getSellerDetails();
    let sendingData = {
      discountedOnReturn: params?.discountedOnReturn,
      userId: params?.userId,
      createdBy: seller.UserID,
      paymentModes: params?.paymentModes,
      totalAmount: params?.totalAmount,
      totalLoyaltyDeduction: params?.totalLoyaltyDeduction,
      returns: params?.returns,
    }
    let url = this.baseUrl + '/Return/ReturnOrderForPOS';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getReturnableProductsQuantityByOrder(params: any) {
    let sendingData = {
      id: params.orderID,
    }
    let url = this.baseUrl + '/Return/GetReturnableProductsQuantityByOrder';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public deleteAllWorksByBranch(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      branchID: params.branchID,
      updatedBy: params.userID,
      updatedOn: new Date(),
    }
    let url = this.baseUrl + '/Servicenear/DeleteAllWorksByBranch';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getServiceSalesList(params: any) {
    let sendingData = {
      key: "",
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      keyWord: params.searchKeyWord,
      orderStatus: "",
      technicianId: params.technicianId,
      shopID: params.shopID,
      showCreditOrdersOnly: params.showCreditOrdersOnly || false
    };
    const url = this.baseUrl + '/Order/GetAllThirdPartyConnectionSalesDetails';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getServiceSalesListSummary(params: any) {
    let sendingData = {
      key: "",
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      keyWord: params.searchKeyWord,
      orderStatus: "",
      technicianId: params.technicianId,
      shopID: params.shopID,
      showCreditOrdersOnly: params.showCreditOrdersOnly || false
    };
    const url = this.baseUrl + '/Order/GetThirdPartyConnectionSalesSummary';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getOutstandingReport(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      // sellerID: 0,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      shopId: params.shopId,
    }
    const url = this.baseUrl + '/Accounts/GetOutstandingReport';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getOutstandingReportSummary(params: any) {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      // sellerID: 0,
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateChecked: params.isDateChecked,
      fromDate: params.fromDate,
      toDate: params.toDate,
      shopId: params.shopId,
    }
    const url = this.baseUrl + '/Accounts/GetOutstandingReportSummary';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllOrdersForAdmin(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      sellerId: userDetails.SellerID,
      userID: 0, //to get all user's orders
      isDateChecked: params.isDateChecked, //true,
      fromDate: params.fromDate, //"2023-07-26T12:55:45.586Z",
      toDate: params.toDate, //"2023-07-26T12:55:45.586Z",
      takeAll: params.takeAll, //true,
      skip: params.skip, //0,
      take: params.take, //0,
      key: params.key, //"",
      keyWord: params.keyWord, //"",
      orderStatus: params.orderStatus, //"",
      directBuyNo: params.directBuyNo, //0,
      unknownUserKey: params.unknownUserKey, //""
      saleType: params.saleType
    }
    let url = this.baseUrl + "/Order/GetAllOrders";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllOrdersSummary(params: any) {
    let sendingData = {
      userID: 0, //to get all user's orders
      isDateChecked: params.isDateChecked, //true,
      fromDate: params.fromDate, //"2023-07-26T12:55:45.586Z",
      toDate: params.toDate, //"2023-07-26T12:55:45.586Z",
      takeAll: params.takeAll, //true,
      skip: params.skip, //0,
      take: params.take, //0,
      key: params.key, //"",
      keyWord: params.keyWord, //"",
      orderStatus: params.orderStatus, //"",
      directBuyNo: params.directBuyNo, //0,
      unknownUserKey: params.unknownUserKey, //""
      saleType: params.saleType
    }
    let url = this.baseUrl + "/Order/GetAllOrdersSummary";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateBranchUserPassword(params: any) {
    const seller = this.getSellerDetails();
    let sendingData = {
      id: params.userId,
      oldPassword: params.oldPassword,
      newPassword: params.newPassword,
      createdBy: params.userId,
      createdOn: new Date(),
    }
    let url = this.baseUrl + "/Servicenear/UpdateBranchUserPassword";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getBranchProfile(params: any) {
    let sendingData = {
      branchID: params.branchID,
      branchName: params.branchName,
    }
    let url = this.baseUrl + "/Servicenear/GetBranchProfile";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateBranchProfile(params: any) {
    let sendingData = {
      id: params.id,
      branchName: params.branchName,
      branchCode: params.branchCode,
      branchAddress: params.branchAddress,
      smsNumber: params.smsNumber,
      place: params.place,
      district: params.district,
      customerCare: params.customerCare,
      adminName: params.adminName,
      username: params.username,
      updatedBy: params.updatedBy,
    }
    let url = this.baseUrl + "/Servicenear/UpdateBranchProfile";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAndSetLocalStorageUserList() {

    return this.getStaffIdAndBrandchId().pipe(
      switchMap((res: any) => {
        if (res?.Result !== "Success" || !res?.ResponseData) {
          return EMPTY;   // <-- cleanly stop here
        }

        const branchId = res?.ResponseData?.BranchId;

        const params = {
          key: "",
          takeAll: true,
          skip: 0,
          take: 0,
          isDateChecked: false,
          fromDate: "",
          toDate: "",
          branchID: branchId,
          userType: ""
        };

        return this.getBranchUsers(params).pipe(
          tap((res2: any) => {
            const userList = res2?.ResponseData || [];
            localStorage.setItem('userList', JSON.stringify(userList));
          })
        );
      })
    );
  }

  public getAndSetLocalStorageShopList() {
    return this.getStaffIdAndBrandchId().pipe(
      switchMap((res: any) => {
        if (res?.Result !== "Success" || !res?.ResponseData) {
          return EMPTY;   // <-- cleanly stop here
        }

        const userID = res?.ResponseData?.UserId;

        return this.getShops(userID).pipe(
          tap((res2: any) => {
            const userList = res2?.ResponseData || [];
            localStorage.setItem('shopList', JSON.stringify(userList));
          })
        );
      })
    );
  }

  public saveSecondhandPurchaseDetails(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      productName: params.productName,
      categoryID: 0,
      sellerName: params.sellerName,
      sellerPhoneNumber: params.sellerPhoneNumber,
      sellerAdditionalInfo: params.sellerAdditionalInfo,
      productSpecification: params.productSpecification,
      images: params.images,
      productConditions: params.productConditions,
      pricings: params.pricings,
      createdBy: Number(userDetails.UserID),
      purchasePayload: params.purchasePayload,
    }
    let url = this.baseUrl + "/Secondhand/SaveSecondhandPurchaseDetails";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public GenerateOTP(phonenumber: number) {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    let url = this.configService.getNoAuthUrl() + '/Order/GenerateOTP?PhoneNumber=' + phonenumber;
    return this.http.get(url, ParseHeaders);
  }

  public compareOTPWithStringReturn(params: any) {
    let url = this.baseUrl + '/Order/CompareOTPWithStringReturn?PhoneNumber=' + params.PhoneNumber + '&OTP=' + params.OTP;
    return this.http.get(url, this.parseHeaders);
  }

  public getSecondhandProductDetailList(params: any) {
    let sendingData = {
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateCheckedForCreated: params.isDateCheckedForCreated,
      isDateCheckedForPurchase: params.isDateCheckedForPurchase,
      isDateCheckedForSales: params.isDateCheckedForSales,
      fromDate: params.fromDate,
      toDate: params.toDate,
      isSold: params.isSold,
      includeSoldAndUnsold: params.includeSoldAndUnsold,
      status: params.status,
    }
    let url = this.baseUrl + "/Secondhand/GetSecondhandProductDetailList";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSecondhandSummary(params: any) {
    let sendingData = {
      key: params.key,
      takeAll: params.takeAll,
      skip: params.skip,
      take: params.take,
      isDateCheckedForCreated: params.isDateCheckedForCreated,
      isDateCheckedForPurchase: params.isDateCheckedForPurchase,
      isDateCheckedForSales: params.isDateCheckedForSales,
      fromDate: params.fromDate,
      toDate: params.toDate,
      isSold: params.isSold,
      includeSoldAndUnsold: params.includeSoldAndUnsold,
      status: params.status,
    }
    let url = this.baseUrl + "/Secondhand/GetSecondhandSummary";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSecondhandDetailsWithID(params: any) {
    let sendingData = {
      secondhandID: params.secondhandID
    }
    let url = this.baseUrl + "/Secondhand/GetSecondhandDetailsWithID";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public saveSecondhandSalesDetails(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      customerName: params.customerName,
      customerPhoneNumber: params.customerPhoneNumber,
      customerAdditionalInfo: params.customerAdditionalInfo,
      secondhandID: params.secondhandID,
      salePayload: params.salePayload,
    }
    let url = this.baseUrl + "/Secondhand/SaveSecondhandSalesDetails";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public uploadFileToDrive(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/GoogleAuth/UploadCustomerPhoto`, formData);
  }

  public updateSecondhandPurchase(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      secondhandID: params.secondhandID,
      sellerName: params.sellerName,
      sellerPhoneNumber: params.sellerPhoneNumber,
      sellerAdditionalInfo: params.sellerAdditionalInfo,
      pricings: {
        purchasePrice: params.pricings.purchasePrice,
        sellingPrice: params.pricings.sellingPrice,
        minSalesPrice: params.pricings.minSalesPrice
      },
      updatedBy: userDetails?.UserID ?? 0,
      purchaseID: params.purchaseID,
      productID: params.productID
    }
    let url = this.baseUrl + "/Secondhand/UpdateSecondhandPurchase";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateSecondhandSale(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      secondhandID: params.secondhandID,
      customerName: params.customerName,
      customerPhoneNumber: params.customerPhoneNumber,
      customerAdditionalInfo: params.customerAdditionalInfo,
      pricings: {
        purchasePrice: params.pricings.purchasePrice,
        sellingPrice: params.pricings.sellingPrice,
        minSalesPrice: params.pricings.minSalesPrice
      },
      updatedBy: userDetails?.UserID ?? 0,
      saleID: params.saleID,
      productID: params.productID,
      soldPrice: params.soldPrice
    }
    let url = this.baseUrl + "/Secondhand/UpdateSecondhandSale";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateSecondhandProductDetails(params: any) {
    let userDetails = this.getLoginDetails();
    let sendingData = {
      secondhandID: params.secondhandID,
      productSpecification: params.productSpecification,
      images: {
        product: params.images.product,
        proof: params.images.proof
      },
      productConditions: params.productConditions,
      updatedBy: userDetails?.UserID ?? 0,
      purchaseID: params.purchaseID,
      saleID: params.saleID,
      productID: params.productID,
      productName: params.productName
    }
    let url = this.baseUrl + "/Secondhand/UpdateSecondhandProductDetails";
    return this.http.post(url, sendingData, this.parseHeaders);
  }


  private loadScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = () => reject('Razorpay SDK failed to load');

      document.body.appendChild(script);
    });
  }

  async openRazorpay(options: any): Promise<any> {
    await this.loadScript();

    return new Promise((resolve, reject) => {
      const rzp = new Razorpay({
        ...options,
        handler: (response: any) => {
          resolve(response);
        },
        modal: {
          ondismiss: () => {
            reject('Payment popup closed');
          }
        }
      });

      rzp.open();
    });
  }

  public verifyRazorpayPayment(params: any) {
    let pgRefrenceDetails = {
      pgPaymentID: params.PGPaymentID,
      pgOrderID: params.PGOrderID,
      pgSignature: params.PGSignature,
    }

    var sendingData = {
      pgPaymentID: params.PGPaymentID,
      pgOrderID: params.PGOrderID,
      pgSignature: params.PGSignature,
      orderNumber: params.OrderNumber,
      pgRefrenceDetails: JSON.stringify(pgRefrenceDetails)
    };

    const url = this.baseUrl + '/Payment/VerifyPaymentUsingPaymentIdForSubscriptionApiModule';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public validateSubscriptionBill(orderID: number) {
    var sendingData = {
      orderID: orderID,
    };

    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/ValidateSubscriptionBillPaymentAndUpdateStatus';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // ===== Subscription Management (Super Admin) =====

  public updateSubscriptionValidityBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      subscriptionId: params.subscriptionId,
      startDateUnix: params.startDateUnix,
      endDateUnix: params.endDateUnix
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/UpdateSubscriptionValidityForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateSubscriptionGracePeriodBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      subscriptionId: params.subscriptionId,
      paymentGracePeriodUnix: params.paymentGracePeriodUnix
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/UpdateSubscriptionGracePeriodForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateSubscriptionFeatureLimitUsageBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      detailId: params.detailId,
      limitValue: params.limitValue,
      usage: params.usage
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/UpdateSubscriptionFeatureLimitUsageForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateSubscriptionBillAmountBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      orderId: params.orderId,
      amount: params.amount
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/UpdateSubscriptionBillAmountForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateSubscriptionExpiredStatusBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      subscriptionId: params.subscriptionId,
      isExpired: params.isExpired
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/UpdateSubscriptionExpiredStatusForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public cancelSubscriptionBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      subscriptionId: params.subscriptionId
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/CancelSubscriptionForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // Adds another plan alongside the current plan(s) - nothing is switched or expired
  public addSubscriptionPlanBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      planId: params.planId,
      startDateUnix: params.startDateUnix || null,
      endDateUnix: params.endDateUnix || null
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/AddSubscriptionPlanForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // Order in which running plans' limits are used - subscriptionIds[0] is used first
  public updateSubscriptionUsageOrderBySellerUuid(params: any) {
    const sendingData = {
      uuid: params.uuid,
      subscriptionIds: params.subscriptionIds
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/UpdateSubscriptionUsageOrderForSuperAdmin';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAllSubscriptionPlansForSuperAdmin(params: any) {
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/GetAllSubscriptionPlansForSuperAdmin?uuid=' + params.uuid;
    return this.http.get(url, this.parseHeaders);
  }

  public getSecondhandEditHistoryList(params: any) {
    let sendingData = {
      takeAll: params.takeAll ?? true,
      skip: params.skip ?? 0,
      take: params.take ?? 0,
      secondhandID: params.secondhandID ?? 0
    }
    let url = this.baseUrl + "/Secondhand/GetSecondhandEditHistory";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getSecondhandHistoryDetailsWithID(params: any) {
    let sendingData = {
      historyID: params.historyID
    }
    let url = this.baseUrl + "/Secondhand/GetSecondhandHistoryDetailsWithID";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getBranchWorkCountDetails(params: any) {
    let url = this.baseUrl + "/Servicenear/GetBranchWorkCountDetails?BranchType=" + params.BranchType;
    return this.http.get(url, this.parseHeaders);
  }

  public getTotalCountAndTodaysTotal(params: any) {
    let url = this.baseUrl + "/Servicenear/GetTotalCountAndTodaysTotal?BranchType=" + params.BranchType;
    return this.http.get(url, this.parseHeaders);
  }

  public getRemoteConfig() {
    let url = this.baseUrl + "/Servicenear/GetRemoteConfig";
    return this.http.get(url, this.parseHeaders);
  }

  public getBranchStatus(params: any) {
    let url = this.baseUrl + "/Servicenear/GetBranchStatus?BranchID=" + params.BranchID + "&SecurityKey=" + params.SecurityKey;
    return this.http.get(url, this.parseHeaders);
  }

  public getUsageInvoicesByBranch(params: any) {
    let sendingData = {
      branchID: params.branchID,
      securityKey: params.securityKey
    }
    let url = this.baseUrl + "/Servicenear/GetUsageInvoicesByBranch";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public migrateServicenearBranchToV2(params: any) {
    let url = this.baseUrl + "/Servicenear/TobeonlineIntegrationForBranch";
    return this.http.post(url, params, this.parseHeaders);
  }

  public updatePaymentStatus(params: any) {
    let sendingData = {
      branchId: params.branchId,
      securityKey: params.securityKey,
      amount: params.amount,
      invoiceDate: params.invoiceDate
    }
    let url = this.baseUrl + "/Servicenear/UpdatePaymentStatus";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateMonthlyCreditLimit(params: any) {
    let sendingData = {
      branchId: params.branchId,
      securityKey: params.securityKey,
      monthlyCreditLimit: params.monthlyCreditLimit
    }
    let url = this.baseUrl + "/Servicenear/UpdateMonthlyCreditLimit";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public changePaymentBannerStatus(params: any) {
    let sendingData = {
      branchId: params.branchId,
      securityKey: params.securityKey
    }
    let url = this.baseUrl + "/Servicenear/ChangePaymentBannerStatus";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public updateDifferentStatusesByType(params: any) {
    let sendingData = {
      branchId: params.branchId,
      securityKey: params.securityKey,
      statusType: params.statusType
    }
    let url = this.baseUrl + "/Servicenear/UpdateDifferentStatusesByType";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getPaymentTransactionDetails(orderIds: string[]) {
    const url = this.baseUrl + "/Order/GetDeliveredAmountModels?orderIds=" + orderIds.join(',');
    return this.http.post(url, this.parseHeaders);
  }

  public getIncomingApps() {
    return localStorage.getItem('incomingApps') ? JSON.parse(localStorage.getItem('incomingApps') ?? '[]') : null;
  }

  // ServiceNear sign-up: ResponseData "Already" when the number has an account (checked before the OTP)
  public servicenearUserExistsCheck(phoneNumber: string) {
    let url = this.baseUrl + "/Servicenear/UserExistsCheck?PhoneNumber=" + phoneNumber;
    return this.http.get(url, this.parseHeaders);
  }

  // ServiceNear sign-up OTP on WhatsApp (the OTP part of Seller/InsertIntoSellerEnqueryList) - verify with Order/CompareOTPWithStringReturn
  public sendRegistrationWhatsAppOTP(phoneNumber: string) {
    let url = this.configService.getNoAuthUrl() + "/Seller/SendRegistrationWhatsAppOTP?contactNumber=" + phoneNumber;
    return this.http.get(url, this.parseHeaders);
  }

  // ServiceNear seller sign-up (servicenear-register) - mobile number is the username
  public servicenearNewCompanyRegistration(params: any) {
    let sendingData = {
      username: params.mobile,
      phoneNumber: params.mobile,
      name: params.mobile, // name + shopName required by ServiceNear - mobile number for now
      shopName: params.mobile,
      password: params.password,
      confirmPassword: params.confirmPassword
    }
    let url = this.baseUrl + "/Servicenear/NewCompanyRegistration";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  // temp key to log the new ServiceNear seller in (/public/login?thirdpartyuserkey=)
  public getServicenearTempKeyForLogin(params: any) {
    let sendingData = {
      branchId: String(params.branchId),
      userId: params.userId
    }
    let url = this.baseUrl + "/Servicenear/GetServicenearTempKeyForLogin";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

}
